"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.router = exports.handleScreeningResponse = exports.handlerClickPreviousPage = exports.handlerClickNextPage = exports.sendScreeningsFromTemplateQuestions = exports.moveToLastPage = exports.handlerMoveNextPage = exports.canSendFinish = exports.sendFinish = exports.findPreviousPage = exports.findNextPage = exports.getAnswers = void 0;
const effects_1 = require("redux-saga/effects");
const question_1 = require("src/utils/question");
const actions_1 = require("src/redux/actions");
const set_1 = require("src/utils/set");
const selectors_1 = require("./selectors");
function* getAnswers() {
    const answersFromQueryParams = yield (0, effects_1.select)(selectors_1.getQueryParamsAnswers);
    const answeredQuestions = new Set();
    const answers = [];
    if (answersFromQueryParams && answersFromQueryParams.length) {
        answers.push(...answersFromQueryParams);
        answersFromQueryParams.map(({ questionId }) => {
            answeredQuestions.add(questionId.toString());
        });
    }
    const questions = yield (0, effects_1.select)(selectors_1.getQuestions);
    const charLimits = yield (0, effects_1.select)(selectors_1.getCharLimits);
    Object.keys(questions).map(key => {
        const id = key.toString();
        if (answeredQuestions.has(id))
            return;
        const question = (0, question_1.createQuestionModel)(questions, Number(id), { charLimits });
        const values = question.getValueAsObj();
        answers.push(Object.assign(Object.assign({}, values), { questionId: id }));
    });
    return answers;
}
exports.getAnswers = getAnswers;
function* findNextPage() {
    const currPageIndex = yield (0, effects_1.select)(selectors_1.getCurrentPageIndex);
    const pagesList = yield (0, effects_1.select)(selectors_1.getPages);
    const conditions = yield (0, effects_1.select)(selectors_1.getSurveyConditions);
    const nextPageIndex = yield (0, effects_1.call)(selectors_1.getNextPageIndex, { pagesList, currPageIndex, conditions });
    return nextPageIndex;
}
exports.findNextPage = findNextPage;
function* findPreviousPage() {
    const currPageIndex = yield (0, effects_1.select)(selectors_1.getCurrentPageIndex);
    const pagesList = yield (0, effects_1.select)(selectors_1.getPages);
    const prevPageIndex = yield (0, effects_1.call)(selectors_1.getPreviousPageIndex, { pagesList, currPageIndex });
    return prevPageIndex;
}
exports.findPreviousPage = findPreviousPage;
function* sendFinish() {
    const slug = yield (0, effects_1.select)(selectors_1.getSlug);
    const answers = yield (0, effects_1.call)(getAnswers);
    yield (0, effects_1.put)((0, actions_1.finishSurveyRequest)(slug, { answers }));
}
exports.sendFinish = sendFinish;
// eslint-disable-next-line complexity
function canSendFinish({ pages, questions, widgets, currPage }) {
    var _a;
    for (const page of pages.slice(currPage)) {
        if (!page.visible) {
            continue;
        }
        const hasBackBtn = (_a = page.backBtn) === null || _a === void 0 ? void 0 : _a.enabled;
        for (const item of page.children) {
            // eslint-disable-next-line max-depth
            if (item.type === 'question' && questions[item.id].visible) {
                return false;
            }
            // eslint-disable-next-line max-depth
            if (hasBackBtn && item.type === 'widget' && widgets[item.id].visible) {
                return false;
            }
        }
    }
    return true;
}
exports.canSendFinish = canSendFinish;
// eslint-disable-next-line max-statements, complexity
function* handlerMoveNextPage() {
    const currPage = yield (0, effects_1.select)(selectors_1.getCurrentPageIndex);
    if (currPage === -1) {
        yield (0, effects_1.put)((0, actions_1.leftLastPage)());
    }
    const isFinished = yield (0, effects_1.select)(selectors_1.getFinishState);
    const isScreenout = yield (0, effects_1.select)(selectors_1.getScreenoutState);
    const isQuotafull = yield (0, effects_1.select)(selectors_1.getQuotafullState);
    if (isFinished || isScreenout || isQuotafull) {
        return;
    }
    if (currPage === -1) {
        return yield (0, effects_1.call)(sendFinish);
    }
    const pages = yield (0, effects_1.select)(selectors_1.getPages);
    const questions = yield (0, effects_1.select)(selectors_1.getQuestions);
    const widgets = yield (0, effects_1.select)(selectors_1.getWidgets);
    const readyToFinish = yield (0, effects_1.call)(canSendFinish, { pages, questions, widgets, currPage });
    if (readyToFinish) {
        return yield (0, effects_1.call)(sendFinish);
    }
}
exports.handlerMoveNextPage = handlerMoveNextPage;
function* moveToLastPage() {
    const currPageIndex = yield (0, effects_1.select)(selectors_1.getCurrentPageIndex);
    yield (0, effects_1.put)((0, actions_1.moveNextPage)({ from: currPageIndex, to: -1 }));
}
exports.moveToLastPage = moveToLastPage;
function getMatchingQuestionQuotaIdsSet(quotaMap, question) {
    const quotaSet = new Set();
    const checkedOptions = question.options.filter(option => option.checked);
    checkedOptions.forEach(option => {
        var _a;
        const quotaIds = (_a = quotaMap === null || quotaMap === void 0 ? void 0 : quotaMap[question.id]) === null || _a === void 0 ? void 0 : _a[option.id];
        if (Array.isArray(quotaIds) && quotaIds.length) {
            quotaIds.forEach(quotaId => quotaSet.add(quotaId));
        }
    });
    return quotaSet;
}
// eslint-disable-next-line max-statements
function* sendScreeningsFromTemplateQuestions(slug) {
    const pageFixedScreeningQuestions = yield (0, effects_1.select)(selectors_1.getCurrentPageTemplateQuestions);
    if (!pageFixedScreeningQuestions.length) {
        return;
    }
    const actions = [];
    const quotaMap = yield (0, effects_1.select)(selectors_1.getQuotaMap);
    const { search } = yield (0, effects_1.select)(selectors_1.getLocation);
    const quotaIdList = yield (0, effects_1.select)(selectors_1.getInterviewQuotaIds);
    // в какие квоты подходит респондент по ответам на скрининговые вопросы
    let interviewQuotaIds = quotaIdList === undefined ? undefined : new Set(quotaIdList);
    // eslint-disable-next-line max-statements
    pageFixedScreeningQuestions.forEach(currQuestion => {
        const questionQuotaIdsSet = getMatchingQuestionQuotaIdsSet(quotaMap, currQuestion);
        const options = currQuestion.options.filter(option => option.checked).map(q => q.id);
        const questionId = currQuestion.id;
        if (interviewQuotaIds === undefined) {
            interviewQuotaIds = questionQuotaIdsSet;
        }
        else {
            interviewQuotaIds = (0, set_1.setIntersection)(interviewQuotaIds, questionQuotaIdsSet);
        }
        if (interviewQuotaIds.size === 0) {
            return;
        }
        const quotaIds = Array.from(interviewQuotaIds);
        actions.push((0, actions_1.setInterviewQuotaIds)(quotaIds));
        actions.push((0, actions_1.sendScreening)({
            slug,
            questionId,
            options,
            quotaIds,
            queryString: search.substring(1)
        }));
    });
    for (const action of actions) {
        yield (0, effects_1.put)(action);
    }
}
exports.sendScreeningsFromTemplateQuestions = sendScreeningsFromTemplateQuestions;
// eslint-disable-next-line max-statements, complexity
function* handlerClickNextPage(params = {}) {
    const isLogicProcessing = yield (0, effects_1.select)(selectors_1.getLogicProcessing);
    if (isLogicProcessing)
        return;
    // @ts-expect-error TS(2339): Property 'skipValidation' does not exist on type '... Remove this comment to see the full error message
    const { skipValidation = false } = params;
    const invalidQuestionIds = yield (0, effects_1.select)(selectors_1.getInvalidQuestionIdsOnCurrentPage);
    if (!skipValidation && invalidQuestionIds.length) {
        yield (0, effects_1.put)((0, actions_1.showQuestionsErrors)(invalidQuestionIds));
        yield (0, effects_1.put)((0, actions_1.scrollToElement)(invalidQuestionIds[0]));
        return;
    }
    const conditions = yield (0, effects_1.select)(selectors_1.getSurveyConditions);
    if (conditions.skip) {
        return yield (0, effects_1.put)((0, actions_1.surveySkip)());
    }
    const currPageIndex = yield (0, effects_1.select)(selectors_1.getCurrentPageIndex);
    const currPageId = yield (0, effects_1.select)(selectors_1.getCurrentPageId);
    const screenout = yield (0, effects_1.select)(selectors_1.getCurrentPageScreenout);
    const isScreenout = screenout && !screenout.valid;
    const newPageIndex = yield (0, effects_1.call)(findNextPage);
    const slug = yield (0, effects_1.select)(selectors_1.getSlug);
    yield (0, effects_1.put)((0, actions_1.sendAnswersToMetrika)());
    yield (0, effects_1.call)(sendScreeningsFromTemplateQuestions, slug);
    if (newPageIndex !== -1 && !isScreenout) {
        // Если это переход не на страницу "Спасибо", то логируем его
        const newPageId = yield (0, effects_1.select)(selectors_1.getPageId, newPageIndex);
        yield (0, effects_1.put)((0, actions_1.storePageSwitch)(slug, currPageId, newPageId));
    }
    if (isScreenout) {
        const optionIds = yield (0, effects_1.select)(selectors_1.getCurrentPageSelectedOptions);
        const { search } = yield (0, effects_1.select)(selectors_1.getLocation);
        yield (0, effects_1.put)((0, actions_1.leftLastPage)());
        yield (0, effects_1.put)((0, actions_1.sendScreenout)({
            slug,
            pageFrom: currPageIndex,
            optionIds,
            queryString: search.substring(1)
        }));
        return;
    }
    yield (0, effects_1.put)((0, actions_1.moveNextPage)({ from: currPageIndex, to: newPageIndex }));
}
exports.handlerClickNextPage = handlerClickNextPage;
// eslint-disable-next-line max-statements, complexity
function* handlerClickPreviousPage() {
    const currPageIndex = yield (0, effects_1.select)(selectors_1.getCurrentPageIndex);
    const currPageId = yield (0, effects_1.select)(selectors_1.getCurrentPageId);
    const screenout = yield (0, effects_1.select)(selectors_1.getCurrentPageScreenout);
    if (screenout) {
        return;
    }
    const newPageIndex = yield (0, effects_1.call)(findPreviousPage);
    if (newPageIndex !== -1) {
        const slug = yield (0, effects_1.select)(selectors_1.getSlug);
        const newPageId = yield (0, effects_1.select)(selectors_1.getPageId, newPageIndex);
        yield (0, effects_1.put)((0, actions_1.storePageSwitch)(slug, currPageId, newPageId));
    }
    yield (0, effects_1.put)((0, actions_1.moveNextPage)({ from: currPageIndex, to: newPageIndex }));
}
exports.handlerClickPreviousPage = handlerClickPreviousPage;
function* handleScreeningResponse(action) {
    const { redirect } = action.data || {};
    if (redirect) {
        yield (0, effects_1.put)((0, actions_1.setQuotafull)(redirect));
        yield (0, effects_1.call)(moveToLastPage);
    }
}
exports.handleScreeningResponse = handleScreeningResponse;
function* router() {
    yield (0, effects_1.takeEvery)('CLICK_PREVIOUS_PAGE', handlerClickPreviousPage);
    yield (0, effects_1.takeEvery)('CLICK_NEXT_PAGE', handlerClickNextPage);
    yield (0, effects_1.takeEvery)('MOVE_NEXT_PAGE', handlerMoveNextPage);
    yield (0, effects_1.takeEvery)('SURVEY_SCREENOUT_SUCCESS', moveToLastPage);
    yield (0, effects_1.takeEvery)('SURVEY_SCREENING_SUCCESS', handleScreeningResponse);
}
exports.router = router;
